import { useEffect, useState } from 'react';
import { Share, SharesTitle } from 'types';
import { store } from 'redux/store';
import { getPartnerShares } from '../api/getPartnerShares';
import { getSharesTitlesByShares } from '../api/getSharesTitlesByShares';

type UseGetPartnerShares = {
  partnerId: string;
  page: number;
  items: number;
  sortBy?: string;
  sortOrder?: string;
  hasCoOwnershipCategory?: boolean;
  refreshPartnerShares?: number;
};

const DEFAULT_SORT_BY = 'date';
const DEFAULT_SORT_ORDER = 'desc';

export const useGetPartnerShares = ({
  partnerId,
  page,
  items,
  sortBy = DEFAULT_SORT_BY,
  sortOrder = DEFAULT_SORT_ORDER,
  hasCoOwnershipCategory = false,
  refreshPartnerShares = 0,
}: UseGetPartnerShares) => {
  const [partnerShares, setPartnerShares] = useState<Share[]>([]);
  const [coOwnerShares, setCoOwnerShares] = useState<Share[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [sharesTitles, setSharesTitles] = useState<SharesTitle[]>([]);

  useEffect(() => {
    const fetchShares = async () => {
      if (!partnerId) return;

      setIsLoading(true);

      try {
        const params = { page, items, sortBy, sortOrder };

        const sharesData = await store.dispatch(
          getPartnerShares({
            partnerId,
            params,
          })
        );

        const { shares } = sharesData;
        setPartnerShares(shares);

        const sharesIds = shares.map((share: Share) => share._id);

        const sharesTitles = await store.dispatch(
          getSharesTitlesByShares(sharesIds)
        );

        setSharesTitles(sharesTitles || []);
      } catch (error) {
        setPartnerShares([]);
        setCoOwnerShares([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchShares();
  }, [
    partnerId,
    page,
    items,
    sortBy,
    sortOrder,
    hasCoOwnershipCategory,
    refreshPartnerShares,
  ]);

  return {
    data: { partnerShares, sharesTitles },
    isLoading,
  };
};
